/**
 * Asynchronously loads the component
 */
import { createLoader } from 'utils/createLoader';

export default createLoader(() =>
  import(/* webpackChunkName: "okta-login" */ './index')
);
